<template>
  <div class="the-navbar__user-meta flex items-center justify-between" v-if="activeUserInfo.username">

    <!-- Informations utilisateur -->
    <div class="text-right leading-tight hidden sm:block space-y-2">
    <p class="font-semibold text-lg">{{ activeUserInfo.username }}</p>

  </div>

    <!-- Menu déroulant de l'utilisateur -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="hasAvatar && !imageError"
          :src="activeUserInfo.avatar"
          alt=""
          width="40"
          height="40"
          class="rounded-full shadow-lg border-2 border-gray-200 cursor-pointer block"
          @error="imageError = true"
        />
        <div
          v-else
          :style="{ backgroundColor: avatarColor }"
          class="avatar-initials rounded-full shadow-lg border-2 border-white cursor-pointer flex items-center justify-center text-white font-bold"
        >
          {{ userInitials }}
        </div>
      </div>

      <!-- Menu déroulant -->
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul class="min-w-max bg-white rounded-lg shadow-lg">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/configurations/edit-profil').catch(() => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile &amp; Security</span>
          </li>
          <vs-divider class="my-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/settings/menu').catch(() => {})"
          >
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Settings</span>
          </li>
          <vs-divider class="my-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="goToSignature"
          >
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Email signature</span>
          </li>
          <vs-divider class="my-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>

  </div>
</template>

<script>
import moment from "../../../../../node_modules/moment";
import axios from "@/axios.js";

export default {
  data() {
    return {
      imageError: false,
      serverData: {
        cpu: 0,
        freeMem: 0,
        uptime: 0
      }
    };
  },
  computed: {
    activeUserInfo() {
      let date = moment(localStorage.getItem("login-date"));
      let newdate = moment(date.add(23, "hours")).format("DD-MM-YYYY HH:mm:ss");
      const objectls = {
        date: "Token Life: " + newdate,
        username: localStorage.getItem("login-username"),
        email: localStorage.getItem("login-email"),
        avatar: localStorage.getItem("login-avatar")
      };
      this.objectuser = objectls;
      return objectls;
    },
    hasAvatar() {
      const avatar = this.activeUserInfo.avatar;
      if (!avatar) return false;
      const trimmed = String(avatar).trim();
      return trimmed !== "" && trimmed !== "null" && trimmed !== "undefined";
    },
    userInitials() {
      if (!this.activeUserInfo.username) return "??";
      const username = String(this.activeUserInfo.username).trim();
      if (!username) return "??";

      // Séparer par espaces pour avoir les mots
      const words = username.split(/\s+/).filter(w => w && w.length > 0);

      if (words.length >= 2) {
        // Si 2 mots ou plus : première lettre du premier + première lettre du dernier
        const firstLetter = words[0] && words[0][0] ? words[0][0].toUpperCase() : "?";
        const lastLetter = words[words.length - 1] && words[words.length - 1][0]
          ? words[words.length - 1][0].toUpperCase()
          : "?";
        return (firstLetter + lastLetter).substring(0, 2);
      } else if (words.length === 1) {
        // Si un seul mot : les 2 premières lettres
        const word = words[0];
        if (word.length >= 2) {
          return word.substring(0, 2).toUpperCase();
        } else {
          return (word[0] + word[0]).toUpperCase();
        }
      }

      return "??";
    },
    avatarColor() {
      return "#95bea6";
    }
  },
  watch: {
    'activeUserInfo.avatar'() {
      this.imageError = false;
    }
  },
  mounted() {
   /*this.fetchServerStatus();
    setInterval(this.fetchServerStatus, 10000); // actualisation chaque 10s*/
  },
  methods: {

    /*async fetchServerStatus() {
      try {
        const res = await axios.get("https://xylo.codesinn.com/server_log.json");
        this.serverData = res.data;
      } catch (e) {
        console.error("Erreur serveur:", e);
      }
    },*/
    goToSignature() {
      window.location.href = "https://xylo.codesinn.com/signature";
    },
    logout() {
      // If JWT login
      if (localStorage.getItem("accessToken")) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("login-date");
        localStorage.removeItem("login-readonly");
        localStorage.removeItem("xylo:twofa-setup-required");
        this.$router.push("/pages/login").catch(() => {});
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change("admin");
      localStorage.removeItem("userInfo");

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push("/pages/login").catch(() => {});
    }
  },
  created() {
  }
};
</script>

<style scoped>
.con-img img {
  transition: all 0.3s ease;
}

.con-img img:hover {
  transform: scale(1.1);
}

.avatar-initials {
  width: 40px;
  height: 40px;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
  user-select: none;
}

.avatar-initials:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
